// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./js/components/SelectProdCard/select-prod-card.scss
// module id = 871
// module chunks = 0